import { ComputedProductStatus, ProductStockType } from "@/graphql/codegen/graphql"

export const ACTIVE_PRODUCT_STATUSES: ComputedProductStatus[] = [
  ComputedProductStatus.Active,
  ComputedProductStatus.PendingApproval,
]

export const CAS_TOOLTIP_URL = "https://commonchemistry.cas.org/detail?cas_rn=58-08-2"

export const UN_NUMBER_TOOLTIP_URL =
  "https://www.braumillerlaw.com/chemicals-and-the-usmca-its-not-just-how-you-mix-it-to-get-a-reaction-or-not-from-cbp/"

export const PRODUCT_STOCK_TYPE_LABEL_MAP: Record<ProductStockType, string> = {
  [ProductStockType.StockItem]: "In Stock",
  [ProductStockType.NonStockItem]: "Out of Stock",
  [ProductStockType.MadeToOrder]: "Made To Order",
}

export const PRODUCT_STOCK_TYPE_COLOR_MAP = new Map<ProductStockType, string>([
  [ProductStockType.NonStockItem, "error"],
  [ProductStockType.MadeToOrder, "warning"],
  [ProductStockType.StockItem, "success"],
])

export const PRODUCT_STOCK_TYPE_CHIP_COLOR: Record<ProductStockType, "error" | "warning" | "success"> = {
  [ProductStockType.NonStockItem]: "error",
  [ProductStockType.MadeToOrder]: "warning",
  [ProductStockType.StockItem]: "success",
}
